import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, memoryLocalCache, connectFirestoreEmulator } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Firebase config is expected in environment variables (prefixed with REACT_APP_)
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase only once
const app = initializeApp(firebaseConfig);

// Firebase services
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: memoryLocalCache(),
  experimentalForceLongPolling: true,
});
export const functions = getFunctions(app, 'us-central1');

const useEmulators =
  process.env.NODE_ENV === 'development';

if (useEmulators) {
  if (process.env.REACT_APP_USE_EMULATORS_FUNCTIONS === 'true') {
    connectFunctionsEmulator(functions, 'localhost', 5001);
    
  }
  
  if (process.env.REACT_APP_USE_EMULATORS_FIRESTORE === 'true') {
    connectFirestoreEmulator(db, 'localhost', 8080);
    
  }
}

export let analytics: ReturnType<typeof getAnalytics> | undefined;

// Analytics is only available in browsers and when supported (not in Node/test)
(async () => {
  if (await isSupported()) {
    analytics = getAnalytics(app);
  }
})(); 